<!--<button color="primary" mat-raised-button>Add Data</button>-->
<button color="primary" mat-mini-fab matTooltip="Add Data" (click)="openDataDialog($event)">
  <mat-icon inline="false">add</mat-icon>
</button>
